<template>
  <div id="dataRetrieval" class="flex h-full">
    <div class="searchBox" ref="searchBox">
      <!-- 数据检索 -->
      <div class="content mb-20px">
        <div class="searchTwo">
          <el-row :gutter="10" class="inputSearch">
            <el-col
              :span="24"
              v-if="!classList.length && effectiveClick"
              class="flex"
              style="justify-content: center"
            >
              <img src="../../../../../public/images/dataRetrieval.png" alt="" />
            </el-col>
            <el-col :span="20" class="flex border-color-grey-ddd bg-color-white">
              <el-input
                size="small"
                v-model.trim="keyword"
                :placeholder="`${$t('pleaseEnterKeyWords')}`"
                @keyup.enter.native="handleSearch('click')"
                clearable
              ></el-input>
              <el-select
                v-model="standardId"
                :placeholder="`${$t('pleaseSelectAstandard')}`"
                clearable
                filterable
                size="small"
              >
                <el-option
                  v-for="item in standardList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4" class="flex tc">
              <el-button
                type="primary"
                class="iconfont icon-search !h-40px"
                @click="handleSearch('click')"
                >{{ $t('search') }}</el-button
              >
              <el-button
                v-if="classList.length && !effectiveClick"
                type="default"
                class="ml-10px !h-40px"
                @click="hanndleBack()"
                >返回</el-button
              >
            </el-col>
            <el-col :span="24" v-if="!classList.length && effectiveClick">
              <div class="tip mt-10px">
                {{ $t('searchTips') }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 数据列表 -->
      <div class="classList" v-if="classList.length">
        <el-card
          class="box-card mb-10px mr-10px"
          shadow="always"
          v-for="(item, index) in classList"
          :key="index"
        >
          <div class="item flex" style="cursor: pointer" @click="enterDetail(item)">
            <div class="iconfont icon-internet fz-30 text-color-blue mr-10px"></div>
            <el-row class="w-full fz-14" :gutter="10">
              <el-col :span="8" class="font-bold">
                {{ $t('classCode') }}:<span v-html="item.code"></span
              ></el-col>
              <el-col :span="8" class="font-bold">
                {{ $t('className') }}: <span v-html="item.name"></span
              ></el-col>
              <el-col :span="8" class="font-bold">
                {{ $t('类型') }}: <span v-html="item.classTypeName"></span>
              </el-col>
              <el-col :span="8" v-for="(it, index) in item.headers" :key="index">
                <span v-html="it.name"></span>:
                <span v-html="it.value" style="word-wrap: break-word"></span>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div v-if="classList.length" class="mt-10px text-right mr-10px">
        <el-pagination
          background
          @current-change="handleSearch()"
          @size-change="handleSearch('changSize')"
          :current-page.sync="pageNo"
          :page-size.sync="pageSize"
          :page-sizes="[15, 30, 50]"
          layout="total, sizes, prev, pager, next"
          :total="recordCount"
        ></el-pagination>
      </div>
    </div>
    <img
      class="bgImg"
      v-if="!classList.length && effectiveClick"
      src="../../../../../public/images/dataRetrievalBg.png"
      alt=""
    />
  </div>
</template>

<script>
import StandardManagementService from '@/services/common/StandardManagementService'
import StdClassTypeService from '@/services/bsApi/StdClassTypeService'
import ElasticSearchSourceService from '@/services/bsApi/ElasticSearchSourceService'

export default {
  name: 'dataRetrieval',
  data() {
    return {
      keyword: '',
      standardId: '',
      standardList: '',
      checkList: [],
      classTypeList: [],
      classList: [],
      loading: false,
      noMore: false,
      pageNo: 1,
      pageSize: 15,
      recordCount: null,
      effectiveClick: true,
    }
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `/${routerBase}`
    },
    disabled() {
      return this.loading || this.noMore
    },
    currentLang() {
      return this.$store.getters['System/currentLang']
    },
  },
  created() {
    ElasticSearchSourceService.upDateEsData() // 更新搜索引擎数据
    this.getStandardList()
    this.restoreSearchParams()
  },
  mounted() {
    if (this.$route.query.form === 'detail') {
      this.$refs.searchBox.style.margin = 0
      this.effectiveClick = false
    }
  },
  watch: {
    standardId(val) {
      this.checkList = []
      if (val) {
        this.getClassType()
      } else {
        this.classTypeList = []
        this.classList = []
        this.keyword = ''
      }
    },
    keyword(val) {
      if (!val) {
        this.classList.forEach((item) => {
          item.name = this.normalKeyword(item.name)
          item.code = this.normalKeyword(item.code)
          item.parentClassName = this.normalKeyword(item.parentClassName)
          item.headers.forEach((it) => {
            it.name = this.normalKeyword(it.name)
            it.value = this.normalKeyword(it.value)
          })
        })
      }
    },
  },
  methods: {
    saveSearchParams() {
      const searchParams = {
        standardId: this.standardId, // this.standardId
        searchSource: 2, // 代表数据
        keyword: this.keyword,
        pageIndex: this.pageNo,
        pageSize: this.pageSize,
        searchMode: 0,
        classTypes: this.checkList,
        standardList: this.standardList,
        effectiveClick: this.effectiveClick,
        timestamp: Date.now(),
      }
      localStorage.setItem('dataRetrievalSearchParams', JSON.stringify(searchParams))
    },
    async restoreSearchParams() {
      const searchParamsStr = localStorage.getItem('dataRetrievalSearchParams')
      if (searchParamsStr) {
        try {
          const searchParams = JSON.parse(searchParamsStr)
          const ONE_HOUR = 30 * 60 * 1000
          if (Date.now() - searchParams.timestamp > ONE_HOUR) {
            return
          }
          this.pageNo = searchParams.pageNo
          this.pageSize = searchParams.pageSize
          this.checkList = searchParams.classTypes
          this.keyword = searchParams.keyword
          this.standardList = searchParams.standardList
          this.effectiveClick = searchParams.effectiveClick
          const parameter = {
            standardId: searchParams.standardId,
            searchSource: searchParams.searchSource,
            keyword: searchParams.keyword,
            pageIndex: searchParams.pageNo,
            pageSize: searchParams.pageSize,
            searchMode: searchParams.searchMode,
            classTypes: searchParams.checkList,
          }
          const res = await ElasticSearchSourceService.list(parameter)
          if (res && res.code === 0 && res.data) {
            this.classList = res.data
            if (res.data.length === 0) {
              this.$message({
                type: 'warning',
                message: this.$t('searchResultTips'),
              })
              return
            }
            if (res.page) {
              this.recordCount = res.page.recordCount
            }
            this.effectiveClick = false
            this.classList.forEach((item) => {
              if (this.keyword) {
                item.name = this.brightKeyword(item.name)
                item.code = this.brightKeyword(item.code)
                item.parentClassName = this.brightKeyword(item.parentClassName)
              }
              const dataValue = JSON.parse(item.dataValue)
              item.headers.forEach((it) => {
                for (const key in dataValue) {
                  if (it.code.toUpperCase() === key.toUpperCase()) {
                    this.$set(it, 'value', dataValue[key])
                  }
                }
                if (this.keyword) {
                  it.name = this.brightKeyword(it.name)
                  it.value = this.brightKeyword(it.value)
                }
              })
            })
            this.$refs.searchBox.style.margin = 0
          }
        } catch (error) {
          console.error('error: ', error)
        }
      }
    },
    async getStandardList() {
      const res = await StandardManagementService.getList()
      if (res && res.data && res.code === 0) {
        this.standardList = res.data
        if (res.data.length) {
          this.standardId = res.data[0].id
          if (this.$route.query.form === 'detail') {
            this.handleSearch()
          }
        }
      }
    },
    async getClassType() {
      const parameter = {
        standard_id: this.standardId,
      }
      const res = await StdClassTypeService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.classTypeList = res.data
      }
    },
    async handleSearch(type) {
      if (!this.standardId) {
        this.$message({
          type: 'warning',
          message: this.$t('pleaseSelectAstandard'),
        })
        return
      }
      if (this.keyword && (type === 'click' || type === 'changSize')) {
        this.pageNo = 1
      }
      const parameter = {
        standardId: this.standardId, // this.standardId
        searchSource: 2, // 代表数据
        keyword: this.keyword,
        pageIndex: this.pageNo,
        pageSize: this.pageSize,
        searchMode: 0,
        classTypes: this.checkList,
      }
      this.saveSearchParams()
      const res = await ElasticSearchSourceService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.classList = res.data
        if (res.data.length === 0) {
          this.$message({
            type: 'warning',
            message: this.$t('searchResultTips'),
          })
          return
        }
        if (res.page) {
          this.recordCount = res.page.recordCount
        }
        this.effectiveClick = false
        this.classList.forEach((item) => {
          if (this.keyword) {
            item.name = this.brightKeyword(item.name)
            item.code = this.brightKeyword(item.code)
            item.parentClassName = this.brightKeyword(item.parentClassName)
          }
          const dataValue = JSON.parse(item.dataValue)
          item.headers.forEach((it) => {
            // eslint-disable-next-line no-restricted-syntax
            for (const key in dataValue) {
              if (it.code.toUpperCase() === key.toUpperCase()) {
                this.$set(it, 'value', dataValue[key])
              }
            }
            if (this.keyword) {
              it.name = this.brightKeyword(it.name)
              it.value = this.brightKeyword(it.value)
            }
          })
        })
        this.$refs.searchBox.style.margin = 0
      }
    },
    hanndleBack() {
      this.keyword = ''
      this.classList = []
      this.effectiveClick = true
      this.$refs.searchBox.style.marginLeft = '25%'
      this.$refs.searchBox.style.marginTop = '10%'
    },
    brightKeyword(val) {
      if (!val) {
        return
      }
      const keyword = this.keyword
      const arr = keyword.split('*')
      let string = ''
      for (let i = 0; i < arr.length; i = i + 1) {
        if (`${val}`.indexOf(arr[i]) !== -1 && arr[i]) {
          if (string === '') {
            string = `${val}`.replace(arr[i], `<font style="color: red">${arr[i]}</font>`)
          } else {
            string = string.replace(arr[i], `<font style="color: red">${arr[i]}</font>`)
          }
        } else {
          string = string || val
        }
      }
      return string
    },
    normalKeyword(val) {
      if (!val) {
        return
      }
      const string = `${val}`.replace(/<font style="color: red">/g, '')
      return string.replace(/<\/font>/g, '')
    },
    enterDetail(obj) {
      if (obj.classTypeCode === 'Document') {
        this.$router.push({
          path: `${this.basePath}/legacy-resource/data-collection-manage/doc-view`,
          query: {
            documentId: obj.id,
            title: encodeURIComponent(obj.name),
            standardId: this.standardId,
            classId: obj.classId,
          },
        })
      } else {
        this.$router.push({
          path: './asset-view',
          query: {
            id: obj.id,
            classId: obj.classId,
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>

#dataRetrieval {
  // background-color: rgba(250, 250, 250, 0.5);
  padding: 10px;
  position: relative;
  .bgImg {
    position: absolute;
    left: 10%;
    bottom: 0;
    width: 70%;
    height: 50%;
  }
  .searchBox {
    width: 100%;
    margin-left: 25%;
    margin-top: 10%;
    .content {
      width: 100%;
      .searchTwo {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        img {
          width: 38%;
          margin-bottom: 10px;
        }
        .inputSearch {
          width: 60%;
        }
      }
    }
  }
  .classList {
    height: calc(100vh - 245px);
    overflow: auto;
  }
  /deep/.el-input--small .el-input__inner {
    height: 40px !important;
    line-height: 40px !important;
    border: none !important;
  }
  /deep/.el-tabs__nav-scroll {
    background: #fff;
    padding: 0 10px;
    font-size: 16px;
  }
  /deep/.el-tabs__item {
    font-weight: bolder;
  }
  /deep/ .el-card__body {
    padding: 5px 10px !important;
  }
  .item {
    justify-content: center;
    align-items: center;
  }
}

</style>
